import React from "react";
import { useCompany, useTicket } from "../../store/Store";

const CompanyInfo = () => {
  const { data: companyData } = useCompany();
  const { data: ticketData } = useTicket();

  const {
    name: companyName,
    phone_number: companyPhone,
    marketing_logo: companyLogo,
  } = companyData || {};

  const location = ticketData?.resource?.location;

  if (!companyData) return null;

  return (
    <div className="flex align-center text-center min-[920px]:text-left w-full border-t md:border-b border-gray-200 px-5 py-2">
      <div className="flex flex-col min-[920px]:flex-row items-center justify-center min-[920px]:justify-start w-full">
        {companyLogo?.original && (
          <img
            className="max-w-[80px] rounded-md"
            src={companyLogo?.original}
            alt={companyName}
          />
        )}
        <h1
          className="text-lg font-bold text-black min-[920px]:pl-3 min-[920px]:pr-3 mt-2 min-[920px]:mt-0"
          data-testid="company-name"
        >
          {companyName}
        </h1>
        {location && (
          <div className="flex flex-col min-[920px]:flex-row align-center text-base text-black-light mt-1 min-[920px]:mt-0">
            <div data-testid="location-address">
              {location.street_address}
              {location.street_address_2
                ? `, ${location.street_address_2}`
                : ""}
              ,
            </div>
            <div className="min-[920px]:pl-1" data-testid="location-city-state">
              {location.city}, {location.state} {location.zip_code}{" "}
              <span className="hidden min-[920px]:inline">|</span>
            </div>
            <div className="min-[920px]:pl-1 text-black-light" data-testid="company-phone">
              {companyPhone}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyInfo;
